/**
 * Normalizes a raw phone number to a 10-digit string of digits.
 *
 * Strips all non-digit characters. If the result is 11 digits starting with
 * "1" (NANP country code), drops the leading digit. Applies equally to US and
 * Canadian phone numbers since both use NANP.
 *
 * @example
 * normalizePhone("14165550123")    // "4165550123"
 * normalizePhone("+1 416 555 0123") // "4165550123"
 * normalizePhone("4165550123")     // "4165550123"
 * normalizePhone("(555) 123-4567") // "5551234567"
 */
function normalizePhone(rawValue: string): string {
  const digits = rawValue.replace(/\D/g, "");
  return digits.length === 11 && digits.startsWith("1")
    ? digits.slice(1)
    : digits;
}

export { normalizePhone };
